var map = {
	"./Coursera.png": 80,
	"./Samsung.png": 81,
	"./b.png": 82,
	"./buld.jpg": 83,
	"./cwoc.png": 84,
	"./efi.png": 85,
	"./fctrz.webp": 86,
	"./flutter.png": 87,
	"./gdg.png": 88,
	"./gendigital.png": 89,
	"./gendigital.svg": 90,
	"./github.png": 91,
	"./googleAssistant.jpg": 92,
	"./google_logo.png": 93,
	"./gtu.png": 94,
	"./guvi.png": 95,
	"./hackathon1.svg": 96,
	"./harikrushn.jpg": 97,
	"./iit.png": 98,
	"./ino.png": 99,
	"./localguide.gif": 100,
	"./localguide.png": 101,
	"./mlh-logo.png": 102,
	"./mlh-logo.svg": 103,
	"./mlh.png": 104,
	"./mongo.png": 105,
	"./nightowls.jpg": 106,
	"./node.png": 107,
	"./pipecandy.png": 108,
	"./portfolio1.gif": 109,
	"./postman.jpg": 110,
	"./postman.png": 111,
	"./rakesh.jpeg": 112,
	"./react.png": 113,
	"./ritlogo.jpeg": 114,
	"./skillenza.png": 115,
	"./ssec.png": 116,
	"./ssgandhy.png": 117,
	"./tradercall.png": 118,
	"./ucdlogo.png": 119,
	"./valora.jpg": 120,
	"./wrighter.jpg": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;